import config from 'react-global-configuration';
import { referenceLoadingStart, referenceLoadingDone } from '../../UI/ReferenceLoading';
export var BlockGet = function BlockGet(blockId) {
  return function (dispatch, getState) {
    dispatch(referenceLoadingStart());
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var DRUPAL_9 = config.get('DRUPAL_9', false);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'block']) || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    fetch("".concat(PATH).concat(DRUPAL_9 ? '' : '/admin/content', "/block/").concat(blockId, "?_format=json"), {
      credentials: credentials,
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(BlockGetLoaded(blockId, response));
      dispatch(referenceLoadingDone());
    }).catch(function () {
      dispatch(referenceLoadingDone());
    });
  };
};
export var BLOCK_GET_LOADED = 'BLOCK_GET_LOADED';
export function BlockGetLoaded(blockId, data) {
  return {
    type: BLOCK_GET_LOADED,
    block_id: blockId,
    data: data
  };
}